module.exports = __webpack_public_path__ + "static/Sol-d9a2c6d6fe75143900fbb230ccb8b007.svg";